export enum RecaptchaAction {
  Login = 'login',
  Signup = 'signup',
  Request = 'request',
  Reset = 'reset',
  Expired = 'expired',
  VerifyLoginOTP = 'verify_login_otp',
  GenerateNewLoginOTP = 'generate_new_login_otp',
}
